import React, { useState } from "react";
import FleetrifyPasswordChecker from "../../../components/Password/password-checker";
import { FleetrifyBgs } from "../../../assets/video";
import SuccessPopup from "../../../components/SuccessPopup";
import { FleetrifyInputField } from "../../../components/Input/input";
import { fleetrifyIcons } from "../../../assets/icons/icons";
import { CheckCircle, EyeOff } from "lucide-react";
import { FleetrifyButton } from "../../../components/Button/customButton";
import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
import { useNavigate } from "react-router-dom";

const Password = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    setIsDisabled(true);
    setShowSuccess(true);
  };

  return (
    <div className="relative flex flex-col lg:flex-row min-h-screen items-center justify-center lg:bg-transparent bg-gray-100">
      {/* Video Section */}
      <div className="relative w-full lg:w-[45%] h-screen lg:h-screen order-2 lg:order-none">
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={FleetrifyBgs} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        {/* Info Box */}
        <div className="hidden lg:block absolute bottom-10 left-1/2 -translate-x-1/2 z-20 p-8 border border-white/30 rounded-lg backdrop-blur-md bg-white/10 w-[85%]">
          <div className="w-10 h-10 bg-white rounded-md mb-4 flex items-center justify-center">
            <img src="../../logo.svg" alt="Fleetrify Icon" className="w-6 h-6" />
          </div>
          <h2 className="text-white text-lg font-semibold text-left">
            Compliance and KYC Check
          </h2>
          <p className="text-white text-sm mt-1 text-left">
            Get started with Fleetrify in sourcing for logistics
          </p>
          <div className="flex space-x-1 mt-4">
            <span className="w-2 h-2 bg-white rounded-full opacity-70"></span>
            <span className="w-2 h-2 bg-white/30 rounded-full"></span>
            <span className="w-2 h-2 bg-white/30 rounded-full"></span>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <div className="w-full lg:w-[55%] flex justify-center items-center absolute lg:static z-30 px-5 top-0 bottom-0 my-auto">
        <form
          onSubmit={handleSubmit}
          className="w-[430px] sm:w-[340px] md:w-[500px] lg:w-[430px] max-w-full bg-white px-4 py-6 rounded"
        >
          <div className="space-y-4">
            {/* Password */}
            <div>
              <label className="block text-[#4F4F4F] mb-1 font-bold text-base">
                Password
              </label>
              <FleetrifyInputField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                required
                placeholder="Enter password"
                className="mt-1"
                icon={
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="focus:outline-none"
                  >
                    {showPassword ? <EyeOff size={16} color="#333" /> : fleetrifyIcons.viewIcon}
                  </button>
                }
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label className="block text-[#4F4F4F] mb-1 font-bold text-base">
                Confirm Password
              </label>
              <FleetrifyInputField
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                type={showConfirmPassword ? "text" : "password"}
                required
                placeholder="Re-enter password"
                className="mt-1"
                icon={
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    className="focus:outline-none"
                  >
                    {showConfirmPassword ? <EyeOff size={16} color="#333" /> : fleetrifyIcons.viewIcon}
                  </button>
                }
              />
              <FleetrifyPasswordChecker password={confirmPassword} />
            </div>
          </div>

          <FleetrifyButton type="submit" disabled={isDisabled} className="w-full mt-6">
            Verify
          </FleetrifyButton>
        </form>

        {showSuccess && (
          <SuccessPopup
            content={
              <>
                <div className="bg-white p-4 rounded-full mb-4">
                  <CheckCircle className="text-green-600 w-10 h-10" />
                </div>
                <p className="text-[#4F4F4F] text-bold text-base font-medium">
                  Congratulations! You have successfully created your account!
                </p>
              </>
            }
            actions={
              <>
                <button
                  onClick={() => navigate(FLEETRIFYROUTEPATH.LOGIN)}
                  className="border border-[#143887] text-[#143887] px-2 rounded-md w-full md:w-1/2 text-sm"
                >
                  Setup Company’s Profile
                </button>
                <button
                  onClick={() => navigate(FLEETRIFYROUTEPATH.LOGIN)}
                  className="bg-[#143887] text-white px-2 py-2 rounded-md w-full md:w-1/2 text-sm"
                >
                  Login
                </button>
              </>
            }
            onClose={() => setShowSuccess(false)}
          />
        )}
      </div>
    </div>
  );
};

export default Password;
